
/// La direccion de su contrato acá ///////////////////////////////////
const contractAddress = "TJE8gGkYX7YxzjfrsJb5GZdiny6o94QNEb";

export default contractAddress;